import {
  DownloadDashboardResultsRequest,
  RetrieveDashboardDetailRequest,
  RetrieveDashboardStructureRequest
} from './tracked-session-dashboard.types';

import { API_HOST, HttpGetOptions, getHttpGetOptions } from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/v2/tracked-session-dashboard`;
const getSpecificEndpoint = (sessionEventExternalReference: string) =>
  `${getEndpoint()}/${sessionEventExternalReference}`;

export const getRetrieveDashboardDetailRequest = (data: RetrieveDashboardDetailRequest): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.sessionEventExternalReference)}/detail`,
  getHttpGetOptions(undefined, {
    checkpointIndex: data.checkpointIndex.toString(),
    ...(data.checkpointLapIndex !== undefined && { checkpointLapIndex: data.checkpointLapIndex.toString() })
  })
];

export const getRetrieveDashboardStructureRequest = (
  data: RetrieveDashboardStructureRequest
): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.sessionEventExternalReference)}/structure`,
  getHttpGetOptions()
];

export const getDownloadDashboardResultsRequest = (data: DownloadDashboardResultsRequest): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.sessionEventExternalReference)}/raw-results/spreadsheet`,
  getHttpGetOptions()
];
